import VisitorsDevicesIpadsRoute, {
  type VisitorsDevicesIpadsRouteModel,
} from 'garaje/pods/visitors/devices/ipads/route';

export type VfdDevicesIpadsRouteModel = VisitorsDevicesIpadsRouteModel;

export default class VirtualFrontDeskDevicesIpadsRoute extends VisitorsDevicesIpadsRoute {}
